import { render, staticRenderFns } from "./PaidPaymentTable.vue?vue&type=template&id=166b20f3&scoped=true&"
import script from "./PaidPaymentTable.vue?vue&type=script&lang=js&"
export * from "./PaidPaymentTable.vue?vue&type=script&lang=js&"
import style0 from "./PaidPaymentTable.vue?vue&type=style&index=0&id=166b20f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b20f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCheckbox,VDataTable,VIcon,VSkeletonLoader,VTooltip})
